import cookieAndLocalStorage from "../../helpers/cookieAndLocalStorage";

const FETCH_REQUESTS = 'requests_hr/FETCH_REQUESTS';
const FETCH_REQUESTS_SUCCESS = 'requests_hr/FETCH_REQUESTS_SUCCESS';
const FETCH_REQUESTS_FAIL = 'requests_hr/FETCH_REQUESTS_FAIL';

const SELECT_REQUEST = 'requests_hr/SELECT_REQUEST';

const PUANTAJ_TRANSFER = 'request_hr/PUANTAJ_TRANSFER';
const PUANTAJ_TRANSFER_SUCCESS = 'request_hr/PUANTAJ_TRANSFER_SUCCESS';
const PUANTAJ_TRANSFER_FAIL = 'request_hr/PUANTAJ_TRANSFER_FAIL';

const PUANTAJ_TRANSFER_All = 'request_hr/PUANTAJ_TRANSFER_All';
const PUANTAJ_TRANSFER_SUCCESS_All = 'request_hr/PUANTAJ_TRANSFER_SUCCESS_All';
const PUANTAJ_TRANSFER_FAIL_All = 'request_hr/PUANTAJ_TRANSFER_FAIL_All';

const CLEAR_STATE = 'CLEAR_STATE';

const initialState = {
  selectedRequests: [],
  requests: [],
  pageCount: 1,
  loading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_REQUESTS:
      return {
        ...state,
        loading: true,
      };
    case FETCH_REQUESTS_SUCCESS:
      const selectedRequests = action.result.data.data.filter(
        request => !state.selectedRequests.some(
          r => r.employmentId === request.employmentId),
      )
        .filter(request => request !== undefined && request.uploaded !== 1)
        .map((request) => {
          request.selected = true;

          return request;
        });

     return {
        ...state,
        loading: false,
        requests: (action.result.data ? action.result.data.data : []),
        selectedRequests: state.selectedRequests.length > 0
          ? state.selectedRequests.concat(selectedRequests)
          : action.result.data.data.filter(
            request => request !== undefined && request.uploaded !== 1)
            .map((request) => {
              request.selected = true;

              return request;
            }),
        pageCount: (action.result.data ? action.result.data.pageCount : 1),
      };
    case FETCH_REQUESTS_FAIL:
      return {
        ...initialState,
        loading: false,
        error: action.error.data,
      };
    case SELECT_REQUEST:
      return {
        ...state,
        selectedRequests: state.selectedRequests.filter((request) => {
          if (request.employmentId === action.payload.employmentId) {
            request.selected = action.payload.selected;
          }

          return request;
        }),
        page: action.payload.pageCount
      };
    case PUANTAJ_TRANSFER:
      return {
        ...state,
      };
    case PUANTAJ_TRANSFER_SUCCESS:
      return {
        ...state,
        selectedRequests: state.selectedRequests.filter(
          request => !request.selected),
        requests: state.requests.filter(request => !action.result.data.some(
          r => r.employmentId === request.employmentId)),
      };
    case PUANTAJ_TRANSFER_FAIL:
      return {
        ...state,
      };
      case PUANTAJ_TRANSFER_All:
        return {
          ...state,
        };
      case PUANTAJ_TRANSFER_SUCCESS_All:
        return {
         ...initialState
        };
      case PUANTAJ_TRANSFER_FAIL_All:
        return {
          ...state,
        };
    case CLEAR_STATE:
      return {
        ...initialState
      };
    default:
      return state;
  }
}

export function puantajTransfer(payload) {
  return {
    types: [PUANTAJ_TRANSFER, PUANTAJ_TRANSFER_SUCCESS, PUANTAJ_TRANSFER_FAIL],
    loading: true,
    promise: client => client.post('/hr/puantaj/transfer',
      { data: { harcirahData: payload } }),
  };
}

export function allPuantajTransfer(month, year) {
  let params = { month, year }
  return {
    types: [PUANTAJ_TRANSFER_All, PUANTAJ_TRANSFER_SUCCESS_All, PUANTAJ_TRANSFER_FAIL_All],
    loading: true,
    promise: client => client.post('/hr/puantaj/transferAll', { data: {}, params }),
  };
}

export function selectRequest(selected, employmentId, pageCount) {
  return {
    type: SELECT_REQUEST,
    payload: { selected, employmentId, pageCount },
  };
}

export function clearState() {
  return {
    type: CLEAR_STATE
  };
}

export function fetchRequests(params) {
  return {
    types: [FETCH_REQUESTS, FETCH_REQUESTS_SUCCESS, FETCH_REQUESTS_FAIL],
    loading: true,
    promise: client => client.post('/hr/request/lists', { data: {}, params }),
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/requests-hr.js